export default () => {
  const messages = document.querySelectorAll(
    '.woocommerce-message',
    '.woocommerce-Message'
  )

  const popup = document.querySelector('.js-woocommerce-popup')

  if (popup) return
  if (messages.length < 1) return
  ;[...messages].forEach(message => {
    window.setTimeout(() => {
      message.classList.add('fade')
    }, 3000)

    window.setTimeout(() => {
      message.classList.add('hide')
    }, 4500)
  })
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/Message.js